<template>
    <div class="quick">
        <div class="quick-top">
            <span>
                <img src="../assets/img/home-icon.png" alt="" class="home-icon-img">
                <router-link :to="{ name: 'home' }">首页</router-link>
            </span>&nbsp;/&nbsp;
            <span>
                AI视频创作
            </span>
            <el-button icon="el-icon-back" class="retrunbtn" type="text" @click="urlback">返回</el-button>
        </div>
        <div class="quick-content">
            <el-form :model="ai_form" label-width="120px" class="ai_form" v-loading="loading"
                element-loading-text="AI创作中...">
                <el-form-item label="产品名：">
                    <el-input v-model="ai_form.product_name" style="width:200px;"></el-input>
                </el-form-item>
                <el-form-item label="文件上传：">
                    <el-upload class="upload-demo" action="/api/file/upload" :headers="headers" drag multiple
                        :file-list="fileList" :on-remove="handleRemove" :on-success="handleAvatarSuccess"
                        :before-upload="beforeAvatarUpload" :on-error="uploadError" accept=".mp4,.mov,.jpg,.png"
                        style="width:400px;" :loading="uploading">
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" slot="tip">支持格式.mp4/.mov/.png/.jpg</div>
                    </el-upload>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="ai_Start">确定</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
export default {
    name: 'quick',
    data() {
        return {
            headers: {},
            uploading: false,
            loading: false,
            //一键创作
            ai_form: {
                product_name: '',
            },
            ai_active: 1,
            fileList: [],
            file_ids: [],
        }
    },
    created() {
        this.headers = { Authorization: 'Bearer ' + localStorage.getItem('ai-token') };
    },
    methods: {
        //文件上传
        beforeAvatarUpload(file) {
            let maxsize = 1024 * 1024 * 512;
            if (file.size > maxsize) {
                this.$message.error("文件太大超过了500M");
                return false;
            }
            this.uploading = true;
        },
        handleAvatarSuccess(res, file) {
            this.$message.closeAll();
            if (res.code == 200) {
                this.$message.success("上传完成");
                this.file_ids.push(res.data.file_id);
            } else {
                this.$message.error(file.name + res.msg);
            }
            this.uploading = false;
        },
        uploadError(error, file) {
            this.$message.closeAll();
            this.$message.error(file.name + " 上传失败" + error);
            this.uploading = false;
        },
        handleRemove(file, fileList) {
            this.$post('/file/del', { file_id: file.response.data.file_id }).then(res => {
                if (res.code == 200) {
                    this.$message.success(file.name + " 删除完成");
                } else {
                    this.$message.error(file.name + " 上传失败" + res.msg);
                }
            })
        },
        // AI创作
        async ai_Start() {
            let product_name = this.ai_form.product_name.trim();
            let file_ids = this.file_ids;
            if (product_name.length == 0) {
                this.$message.error("产品名是必须的");
                return;
            }
            if (file_ids.length == 0) {
                this.$message.error("请先上传文件");
                return;
            }
            this.loading = true;
            this.$post('/task/quick_task', { product_name: this.ai_form.product_name, file_ids: this.file_ids }).then(res => {
                if (res.code == 200) {
                    this.$message.success("视频创作完成，请确认。");
                    localStorage.setItem('ai-task', JSON.stringify(res.data));
                    location.href = "/task/detail";
                } else {
                    this.$message.error("创作失败：" + res.msg);
                }
            }).finally(res => {
                this.loading = false;
            })
        },
        urlback() {
            this.$router.go(-1);
        },
    },
}
</script>
<style scoped>
.quick-top {
    width: 100%;
    height: 50px;
    background-color: #fff;
    border-radius: 3px;
    margin-bottom: 10px;
    box-sizing: border-box;
    padding: 16px 20px;
}

.quick-top {
    color: #606266;
    font-size: 14px;
}

.quick-top .home-icon-img {
    margin-right: 4px;
}

.quick-top a {
    color: #606266;
}

.quick-top a:hover {
    color: #006cff;
}

.quick-content {
    background-color: #fff;
    box-sizing: border-box;
    padding: 0 20px;
    padding-bottom: 24px;
    overflow-y: auto;
    min-height: 920px;
    position: relative;
}

.ai_form {
    margin-top: 40px;
}
</style>
